module.exports = __webpack_public_path__ + "static/media/jianfa-titile-icon.d8f34e47.png";